/**
 * Small presentational widgets for the dashboard.
 */
export function Kpi({ label, value, sub, positive, accent, testid }) {
  return (
    <div className="border-r border-b border-zinc-200 p-6" data-testid={testid}>
      <div className="overline">{label}</div>
      <div
        className={`h-display text-3xl lg:text-4xl font-black tracking-tighter mt-3 ${
          accent ? "text-klein" : positive === false ? "text-[#FF2A00]" : ""
        }`}
      >
        {value}
      </div>
      {sub && <div className="text-xs text-muted2 mt-2">{sub}</div>}
    </div>
  );
}


export function Feature({ icon, title, desc }) {
  return (
    <div className="border-r border-b border-zinc-200 p-8">
      <div className="text-klein">{icon}</div>
      <div className="h-display text-xl font-bold mt-4">{title}</div>
      <p className="text-sm text-muted2 mt-2 leading-relaxed">{desc}</p>
    </div>
  );
}


export function Empty({ message }) {
  return (
    <div className="h-full w-full flex items-center justify-center text-sm text-muted2 border border-dashed border-zinc-300 p-6">
      {message}
    </div>
  );
}


export function DeltaPill({ label, current, previous, unit = "" }) {
  const delta = Number(current || 0) - Number(previous || 0);
  const rounded = Math.round(delta * 10) / 10;
  const positive = rounded > 0;
  const negative = rounded < 0;
  const tone = positive
    ? "bg-[#E8F5E9] text-[#1B5E20]"
    : negative
      ? "bg-[#FFEBEE] text-[#B71C1C]"
      : "bg-zinc-100 text-muted2";
  const sign = positive ? "+" : "";
  return (
    <span
      className={`text-[11px] font-medium px-2 py-0.5 ${tone}`}
      data-testid="delta-pill"
      title={`Actual ${current}${unit} vs anterior ${previous}${unit}`}
    >
      {label} {sign}
      {rounded}
      {unit}
    </span>
  );
}
